// extracted by mini-css-extract-plugin
module.exports = {"HorizLine":"HorizLine_HorizLine__16h_u"};